/** Mirror of backend/services/traffic_rules.py constants. */
export const NO_CAP = -1;
/** System default when unset: unlimited. */
export const DEFAULT_CLICK_CAP = NO_CAP;

/** Canonical traffic types — keep in sync with services/traffic_rules.py. */
export const TRAFFIC_TYPES = [
  "domain_redirect",
  "search_syndication",
  "programmatic_rtb",
  "direct_publisher",
  "incentivized",
  "toolbar_extension",
  "coupon_promo",
  "bnpl_financing",
  "cashback_loyalty",
  "trademark_bidding",
  "forced_clicks",
];

/** Resolve the cap value shown in admin UI / merchant feed. */
export function effectiveClickCap(stored, fallbackEffective = null) {
  if (stored === NO_CAP) {
    return { value: NO_CAP, label: "no cap" };
  }
  if (stored !== null && stored !== undefined) {
    return { value: stored, label: `${Number(stored).toLocaleString()}/day` };
  }
  const effective = fallbackEffective ?? DEFAULT_CLICK_CAP;
  if (effective === NO_CAP) {
    return { value: NO_CAP, label: "no cap" };
  }
  return {
    value: effective,
    label: `${Number(effective).toLocaleString()}/day`,
    isDefault: effective === DEFAULT_CLICK_CAP,
  };
}
